import axios from "@/api/axiosInstance";
import {
  CreateEmployeeProfileRequest,
  CreateEmployeeProfileResponse,
} from "./types";

export const createEmployeeProfile = async (
  requestData: CreateEmployeeProfileRequest,
): Promise<CreateEmployeeProfileResponse> => {
  const response = await axios.post<CreateEmployeeProfileResponse>(
    "/api/private/employee-directory/profiles",
    requestData,
  );
  return response.data;
};
